import React, { Component } from 'react';
// import AdminHeader from './Header';
import classes from 'cssClasses';
import style from './admin-page.scss';

import Header from './Header/Header';
import Sidebar from './Sidebar/Sidebar';

class PublicPage extends Component{
	// constructor(props){
	// 	super(props)
	// }

	render(){

		return (
			<div>
				<Header /> 
		    <div className={classes('container-fluid')}>
			    <div className={classes('row')}>
	    			<div className={classes('col-md-3 col-lg-2 d-none d-md-block bg-light sidebar',style)}>
				    	<Sidebar />
				    </div>
						<main className={classes('main-container col-md-9 ml-sm-auto col-lg-10 px-4',style)}>
							<div className={classes('main-content',style)}>
								{this.props.children}
							</div>
						</main>
			    </div>
		    </div>
			</div>
			);
	}
}
export default PublicPage;


// WEBPACK FOOTER //
// ./src/components/Backend/Layout/Layout.js